<template>
  <div>
    <router-link to="/">Back</router-link>
    <h2 class="title is-2">Edit Post</h2>
    <b-loading :active="loading > 0"></b-loading>
    <post-form v-if="editable"
              :post="editable"
              @save="save"></post-form>
  </div>
</template>

<script>
import PostForm from './form'
import HasPost from '@/mixins/has-post'
import { EditablePost, EditableContent, EditableMedia } from '@/utils/editable'
// import { DataStore } from 'aws-amplify'
export default {
  mixins: [ HasPost ],
  components: {
    PostForm
  },
  data () {
    return {
      editable: null
    }
  },
  methods: {
    onLoad () {
      this.editable = new EditablePost(this.post, {
        'Content': this.contents.map(i => {
          const media = this.mediaFor(i.id)
          const editable = new EditableContent(i, {
            Media: media.map(m => new EditableMedia(m))
          })
          return editable
        })
      })
    },
    async save () {
      this.loading++
      await this.editable.save()
      // DataStore.start()
      this.loading--
      this.$router.push({ name: 'post.show', params: { id: this.post.id }})
    }
  }
}
</script>
